import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const ExpenseDetail = () => {
  const { state } = useLocation();

  // Initialize form state with passed data or defaults
  const [form, setForm] = useState({
    date: '',
    vendor: state?.vendor || '',
    phone: state?.phone || '',
    others: '',
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', form);
    // Add your logic to save or process the form
  };

  return (
    <div className="p-6  mx-auto text-gray-800">
      <h1 className="text-xl font-bold mb-4">Expense Detail</h1>

      <p className='text-black text-center'>Enter Amount</p>
       <p className='text-black text-center text-2xl'>$0.06</p>

      {/* Date */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Date</label>
        <input
          type="date"
          name="date"
          value={form.date}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
        />
      </div>

      {/* Vendor */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Vendor</label>
        <input
          type="text"
          name="vendor"
          value={form.vendor}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
        />
      </div>

      {/* Vendor Mobile Number */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Vendor Mobile Number</label>
        <input
          type="text"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
        />
      </div>

      {/* Others */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Others</label>
        <input
          type="text"
          name="others"
          value={form.others}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
        />
      </div>

      {/* Notes */}
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">Notes</label>
        <textarea
          name="notes"
          value={form.notes}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded text-sm"
          rows="3"
        />
      </div>

      <button
        onClick={handleSubmit}
        className="w-full bg-primary text-white py-2 rounded mt-4"
      >
        Save
      </button>
    </div>
  );
};

export default ExpenseDetail;
